import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function getSafeAuthReturnPath(path: string | null): string {
	return path?.startsWith('/') && !path.startsWith('//') ? path : '/';
}

export function formatDate(dateString: string): string {
	return new Date(dateString).toLocaleDateString('en-GB', {
		day: 'numeric',
		month: 'numeric',
		year: 'numeric',
	}) + ' ' + new Date(dateString).toLocaleTimeString('en-GB', {
		hour: 'numeric',
		minute: 'numeric',
		second: 'numeric',
	});
}

export function isValidIP(ip: string): boolean {
	if (isValidIPv4(ip)) return true;
	if (!ip.includes(':') || ip.includes('%') || ip.includes('[') || ip.includes(']')) {
		return false;
	}

	let normalized = ip;
	if (ip.includes('.')) {
		const finalColon = ip.lastIndexOf(':');
		const ipv4Tail = ip.slice(finalColon + 1);
		if (finalColon < 0 || !isValidIPv4(ipv4Tail)) return false;
		normalized = `${ip.slice(0, finalColon + 1)}0:0`;
	}

	const compressionIndex = normalized.indexOf('::');
	const hasCompression = compressionIndex >= 0;
	if (hasCompression && compressionIndex !== normalized.lastIndexOf('::')) return false;

	const sides = hasCompression ? normalized.split('::') : [normalized];
	const groups = sides.flatMap((side) => side === '' ? [] : side.split(':'));
	if (groups.some((group) => !/^[0-9a-f]{1,4}$/i.test(group))) return false;

	return hasCompression ? groups.length < 8 : groups.length === 8;
}

function isValidIPv4(ip: string): boolean {
	const octets = ip.split('.');
	return octets.length === 4 && octets.every((octet) =>
		/^(?:0|[1-9]\d{0,2})$/.test(octet) && Number(octet) <= 255,
	);
}
